import { render, staticRenderFns } from "./SupplierModuleMatrix.vue?vue&type=template&id=44dc3a26&scoped=true"
import script from "./SupplierModuleMatrix.vue?vue&type=script&lang=ts"
export * from "./SupplierModuleMatrix.vue?vue&type=script&lang=ts"
import style0 from "./SupplierModuleMatrix.vue?vue&type=style&index=0&id=44dc3a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dc3a26",
  null
  
)

export default component.exports